export * from './lib/footer/footer.component';
